import { ApolloError, useQuery } from '@apollo/client'
import { NetworksCompaniesCountriesYearsQuery, NetworksCompaniesCountriesYearsQueryVariables } from '../../types'
import { NETWORKS_COMPANIES_COUNTRIES_YEARS } from './Queries'

export default (): {
  data: NetworksCompaniesCountriesYearsQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<NetworksCompaniesCountriesYearsQuery, NetworksCompaniesCountriesYearsQueryVariables>(
    NETWORKS_COMPANIES_COUNTRIES_YEARS,
  )

  return { data, error, loading }
}
